module.exports = __webpack_public_path__ + "img/ban3.c3ad43c9.jpg";